import { zoneName } from '../lib/format';

/** The calendar day an instant falls on at a site, as YYYY-MM-DD. */
const dayAt = (at: number, timeZone: string) => new Date(at).toLocaleDateString('en-CA', { timeZone });

/**
 * When something happened, on the site's clock, as briefly as the day allows: "10:42 AM PT" today,
 * "yesterday", "Sep 15" before that. A time of day names its zone, so two sites' clocks side by
 * side, a transfer sent in California and closed in Maryland, never read as hours apart.
 */
export function siteWhen(iso: string, timeZone: string, now: number = Date.now()): string {
  const at = Date.parse(iso);
  const day = dayAt(at, timeZone);
  if (day === dayAt(now, timeZone)) return `${new Date(at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone })} ${zoneName(new Date(at), timeZone)}`.trimEnd();
  if (day === dayAt(now - 86_400_000, timeZone)) return 'yesterday';
  return new Date(at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone });
}
